type Props = {
  maintainMsg?: string
}
export const EmptyDataSports = ({ maintainMsg }: Props) => {
  return <div className='text-primary text-18 font-bold'>{maintainMsg || '일치하는 항목이 없습니다.'}</div>
}
